// Billing client — talks to the backend /billing routes (backend/api/billingApi.js).
// Accounts are per-ORG: every call carries the current orgId and the backend
// validates membership (checkout/portal additionally require owner/admin).
import { idToken } from './orgs';

const API = process.env.REACT_APP_UPLOAD_API || '';

async function call(path, { method = 'GET', body } = {}) {
  const token = await idToken();
  const res = await fetch(`${API}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `billing request failed (${res.status})`);
  return data;
}

// Public display catalog: { plans, packs, freeEntitlements }.
export const fetchPlans = () => call('/billing/plans');

// The org's account: subscription, entitlements, prepaid credits, month usage.
export const fetchBillingAccount = (orgId) =>
  call(`/billing/account?orgId=${encodeURIComponent(orgId)}`);

// Usage breakdown (owner/admin only): last N months of the token ledger —
// { months: [{ month, total, byKind, byDeal }], dealNames: { dealId: name|null } }
// (null name = the project was deleted; its spend stays on the ledger).
export const fetchUsage = (orgId, months = 6) =>
  call(`/billing/usage?orgId=${encodeURIComponent(orgId)}&months=${months}`);

// Start a Stripe Checkout (planKey = license [interval 'month'|'year',
// seats = extra seats beyond the plan's included count], packKey = one-time
// token pack) and follow the redirect.
export async function startCheckout({ orgId, planKey, packKey, interval, seats }) {
  const { url } = await call('/billing/checkout', { method: 'POST', body: { orgId, planKey, packKey, interval, seats } });
  if (!url) throw new Error('no checkout url returned');
  window.location.assign(url);
}

// Stripe customer portal (manage payment method / cancel).
export async function openPortal(orgId) {
  const { url } = await call('/billing/portal', { method: 'POST', body: { orgId } });
  if (!url) throw new Error('no portal url returned');
  window.location.assign(url);
}
